var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row mb-2 mb-md-4" },
    _vm._l(
      _vm.zoneReassuranceEquipments.zoneReassuranceEquipmentsItem,
      function (zoneReassuranceEquipmentsItem, index) {
        return _c(
          "div",
          { key: index, staticClass: "col-12 col-md-4 mt-1 mt-md-0" },
          [
            _c(
              "ob1-cards",
              {
                staticClass: "h-100 d-flex flex-column text-center p-1 p-lg-2",
                attrs: { "with-composite-link": false },
              },
              [
                _c("h3", { staticClass: "title mb-0" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(zoneReassuranceEquipmentsItem.title) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb-0 mb-md-1" }, [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(zoneReassuranceEquipmentsItem.text),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("ob1-liens", {
                  staticClass: "standard mt-auto mw-100",
                  attrs: {
                    text: zoneReassuranceEquipmentsItem.linkLabel,
                    href: zoneReassuranceEquipmentsItem.linkUrl,
                    "with-arrow": true,
                    "data-oevent-category":
                      zoneReassuranceEquipmentsItem.tms.tagZone + (index + 1),
                    "data-oevent-action": _vm.tagName(
                      zoneReassuranceEquipmentsItem.linkLabel
                    ),
                    "data-oevent-label": zoneReassuranceEquipmentsItem.linkUrl,
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      }
    ),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }